
export default {
  BUILD_ENV: process.env.REACT_APP_ENV || 'local',
};

export const STUB_TOKEN = 'stubToken';
